// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2s8oD","clinicsSelect":"styles_clinicsSelect__33cpr"};